<template>
	<footer>
		<div class="legals">
			<a href="https://www.spotify.com/au/legal/end-user-agreement" target="_blank" @click="gaEvent('Footer', 'Clicked User Agreement')">Legal</a>
			<a href="https://www.spotify.com/au/legal/privacy-policy" target="_blank" @click="gaEvent('Footer', 'Clicked Privacy Policy')">Privacy</a>
			<a href="https://www.spotify.com/au/legal/cookies-policy" target="_blank" @click="gaEvent('Footer', 'Clicked Cookies Policy')">Cookies</a>
			<a @click="gaEvent('Footer', 'Clicked Revoke Access'); showRevokeAccessDialog()">Revoke Access</a>
		</div>
	</footer>
</template>

<script>
export default {
	methods: {
		showRevokeAccessDialog() {
			alert(
				'In order to facilitate a personal experience for you when you engage with this website, we may use your Spotify Account Data when you opt to ‘connect’ your account.\n\n' +
					`If you would like to disconnect your Spotify Account from this website, please visit spotify.com/account/ → Apps → Revoke Access. In this case, you will need to locate: ${window.location.origin}`
			);
		}
	}
};
</script>

<style scoped>
footer {
	width: 100%;
    pointer-events: none;
    z-index: 1;
    position: absolute;
    bottom: 0;
    text-align: center;
}

.legals {
    padding: 0;
    margin-bottom: 1rem;
}

.legals > a {
	margin: 1rem;
	pointer-events: auto;
	font-size: 0.7rem;
}

@media screen and (min-width: 769px) {
	footer {
		justify-content: flex-start;
		width: fit-content;
		margin-left: 7rem;
	}
	footer div {
		border-left: 2px solid white;
	}
}

@media screen and (max-width: 768px) {
	footer {
		bottom: 4rem;
	}
}

</style>
